<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="updateKkm">
            <b-form-group :label="$t('kkm.inspectionName')" label-cols-sm="4">
                <multiselect v-model="selectedTaxOrg" :options="inspections" @input="taxOrgSelected"
                            :close-on-select="true" :hide-selected="true" :showNoResults="false"
                            :custom-label="taxOrgLabel" :placeholder="$t('general.select')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group :label="$t('kkm.registration')" label-cols-sm="4">
                <b-form-input v-model="formData.registrationNumber"></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
export default {
    name: 'editKkmForm',
    props: {
        initData: Object
    },
    data () {
        return {
            isDisabled: false,
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: this.initData.id,
                taxOrganizationId: this.initData.taxId,
                registrationNumber: this.initData.registrationNumber
            },
            selectedTaxOrg: null
        }
    },
    computed: {
        inspections: function () {
            return this.$store.getters.getTaxOrgs
        }
    },
    mounted: function () {
        this.selectedTaxOrg = this.inspections.filter(obj => {
            return obj.id === this.initData.taxId
        })[0]
    },
    methods: {
        updateKkm: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.update,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.updatedMessage')
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
            this.isDisabled = false
        },
        taxOrgSelected: function (value) {
            this.formData.taxOrganizationId = value ? value.id : null
        },
        taxOrgLabel: function ({ code, name }) {
            return `${code} - ${name}`
        }
    }
}
</script>
